var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.584 600.155C621.413 426.818 435.912 296.386 422.763 291.255C389.603 278.314 275.609 288.272 207.284 311.517C138.959 334.762 73.5283 385.227 13.9383 505.087",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.584 410.889C621.413 584.227 435.912 713.788 422.763 718.919C389.603 731.861 275.609 721.902 207.284 698.657C138.959 675.412 73.5283 624.947 13.9383 505.087",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1921 505.087C81.1921 357.529 259.854 237.91 480.244 237.91C700.635 237.91 879.297 357.529 879.297 505.087C879.297 652.645 700.635 772.264 480.244 772.264C259.854 772.264 81.1921 652.645 81.1921 505.087Z",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6879 266.613C98.688 266.613 98.6831 266.624 98.678 266.624C98.673 266.624 98.6445 266.594 98.645 266.573C98.6455 266.552 81.0374 260.878 81.1932 254.924C81.3489 248.971 89.0227 240.653 97.7821 232.34C106.541 224.027 122.052 215.535 146.529 216.176C171.005 216.816 205.419 226.878 239.594 262.89C273.769 298.901 303.053 404.458 300.421 505.087",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6879 743.561C98.688 743.561 98.6831 743.55 98.678 743.55C98.673 743.55 98.6445 743.58 98.645 743.601C98.6455 743.622 81.0374 749.296 81.1932 755.25C81.3489 761.204 89.0227 769.521 97.7821 777.834C106.541 786.147 122.052 794.639 146.529 793.999C171.005 793.358 205.419 783.296 239.594 747.285C273.769 711.273 303.053 605.716 300.421 505.087",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.314 727.524C627.999 726.319 568.826 698.077 566.972 697.293C565.117 696.51 557.443 783.688 506.964 794.954C502.23 796.011 454.185 809.323 432.535 820.952C422.257 826.474 291.324 853.557 296.643 873.935C301.963 894.312 519.166 924.249 551.805 921.411C585.969 918.441 646.609 862.506 684.775 816.518C700.849 797.15 738.342 747.475 756.036 730.824C847.963 644.311 795.764 690.87 861.901 505.087",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.314 282.65C627.999 283.856 568.826 312.097 566.972 312.881C565.117 313.664 557.443 226.486 506.964 215.22C502.23 214.163 454.185 200.852 432.535 189.222C422.257 183.7 291.324 156.617 296.643 136.24C301.963 115.862 519.166 85.9256 551.805 88.7632C585.969 91.7334 646.609 147.668 684.775 193.656C700.849 213.024 738.342 262.699 756.036 279.351C847.963 365.863 795.764 319.304 861.901 505.087",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.667 504.824C711.667 452.945 778.929 410.889 861.901 410.889C944.873 410.889 1012.14 452.945 1012.14 504.824C1012.14 556.703 944.873 598.76 861.901 598.76C778.929 598.76 711.667 556.703 711.667 504.824Z",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.282 505.087C208.282 382.313 310.377 282.785 436.316 282.785C562.256 282.785 652.886 382.313 652.886 505.087C652.886 627.861 562.256 727.389 436.316 727.389C310.377 727.389 208.282 627.861 208.282 505.087Z",
    fill: "#b2d8d8",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeOpacity: 0,
    strokeWidth: 8.52937
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.993 505.087C293.993 430.777 354.234 370.536 428.544 370.536C502.855 370.536 563.095 430.777 563.095 505.087C563.095 517.859 561.316 530.216 557.991 541.922C541.972 598.326 490.082 639.638 428.544 639.638C354.234 639.638 293.993 579.398 293.993 505.087Z",
    fill: "#001e1e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b125c310b3255c743c81ddaca5228f26.svg";
export { ForwardRef as ReactComponent };